import React, { useState } from "react";
import Search from "./components/Search";
import ErrorBoundary from "./components/ErrorBoundary";
import Fallback from "./components/Fallback/Fallback";
import Character from "./components/Character";
import fetchCharacter from "./fetchCharacter";
import "./styles.css";

// lifted from https://github.com/kentcdodds/react-suspense/blob/a3178732f865d16ad5931bfb3a3c75ab6bb69cb1/src/utils.js#L93-L115
function createResource(asyncFn) {
  let status = "pending";
  let result;
  let promise = asyncFn().then(
    asyncResult => {
      status = "success";
      result = asyncResult;
    },
    error => {
      status = "error";
      result = error;
    }
  );
  return {
    read() {
      if (status === "pending") throw promise;
      if (status === "error") throw result;
      if (status === "success") return result;
      throw new Error("This should be impossible");
    }
  };
}

const SUSPENSE_CONFIG = { timeoutMs: 1500 };

export default function App() {
  const [startTransition, isPending] = React.useTransition(SUSPENSE_CONFIG);

  const [characterResource, setCharacterResource] = useState(null);

  const handleSubmit = newCharacterName => {
    // setCharacterResource(
    //   createResource(() => fetchCharacter(newCharacterName))
    // );
    startTransition(() => {
      setCharacterResource(
        createResource(() => fetchCharacter(newCharacterName))
      );
    });
    window.errorComponent && window.errorComponent.tryAgain();
  };

  return (
    <div className="App">
      <h1>React Suspense</h1>
      <p>
        Search for Star Wars characters below and see React.Suspense in action!
      </p>
      <hr />
      <Search onSubmit={handleSubmit} />
      <div className={`character-info${isPending ? " pending" : ""}`}>
        <React.Suspense fallback={<Fallback />}>
          {characterResource ? (
            <ErrorBoundary>
              <Character characterResource={characterResource} />
            </ErrorBoundary>
          ) : (
            "Submit a Character Name"
          )}
        </React.Suspense>
      </div>
    </div>
  );
}
